'use client';
import { getSize, rem } from '@s7/styles';
import { isArray } from '@s7/utils';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const getTypographyVariantSizes = (theme, sizes, { textAlign, radius, width }, size)=>{
    const [computedSize, computedHeight] = isArray(size) ? size : getSize({
        size,
        sizes
    });
    const marginStyles = (()=>{
        const gapExpression = `${rem(computedHeight)} - ${rem(computedSize)}`;
        switch(textAlign){
            case 'start':
                return {
                    marginBottom: `calc(${gapExpression})`
                };
            case 'center':
                return {
                    marginTop: `calc((${gapExpression}) / 2)`,
                    marginBottom: `calc((${gapExpression}) / 2)`
                };
            case 'end':
                return {
                    marginTop: `calc(${gapExpression})`
                };
            default:
                return {};
        }
    })();
    return _extends({}, marginStyles, {
        borderRadius: radius ? theme.fn.borderRadius(radius) : theme.fn.borderRadius('0.5r'),
        height: textAlign ? rem(computedSize) : rem(computedHeight),
        width: width ? width : '100%'
    });
};

export { getTypographyVariantSizes };
//# sourceMappingURL=getTypographyVariantSizes.js.map
